// extracted by mini-css-extract-plugin
module.exports = {"item":"TaskItem_item__1XRlH","check":"TaskItem_check__XG3P-","input":"TaskItem_input__35RvX","item--dark":"TaskItem_item--dark__3hsLj"};